// Master Admin: every staff member's connected accounts, with real status,
// last sync / last error, and a disconnect action.
import React, { useCallback, useEffect, useState } from "react";
import { StatusPill, formatWhen, errorMessage } from "./integrationUi";

const PROVIDER_LABELS = { google_workspace: "Google (Calendar + Gmail)", meta_leadforms: "Meta Lead Ads" };

export default function ConnectionsOverview({ api, showNotice }) {
  const [rows, setRows] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/integrations/connections");
      setRows(data.connections);
    } catch (err) {
      showNotice(errorMessage(err, "Could not load connections"), "error");
    }
  }, [api, showNotice]);

  useEffect(() => { load(); }, [load]);

  const disconnect = async (row) => {
    if (!window.confirm(`Disconnect ${PROVIDER_LABELS[row.provider_id] || row.provider_id} for ${row.user_name || "this user"}?`)) return;
    try {
      await api.post(`/integrations/connections/${row.id}/disconnect`);
      showNotice("Disconnected", "success");
      await load();
    } catch (err) {
      showNotice(errorMessage(err, "Disconnect failed"), "error");
    }
  };

  return (
    <div className="panel glass-panel" data-testid="connections-overview">
      <div className="panel-header"><h3>Connected accounts</h3><span>Per staff member - tokens are never shown</span></div>
      <div className="compact-list">
        {(rows || []).map((r) => (
          <div className="compact-row" key={r.id} data-testid={`connection-row-${r.id}`}>
            <div>
              <strong>{r.user_name || r.user_id} - {PROVIDER_LABELS[r.provider_id] || r.provider_id}</strong>
              <span>
                {r.account_email ? `${r.account_email} - ` : ""}last sync {formatWhen(r.last_sync_at)}
                {r.provider_id === "google_workspace" ? ` - ${r.provider_links || 0} calendar link(s), ${r.events_synced || 0} event(s) pushed` : ""}
              </span>
              {r.last_error && <span style={{ color: "var(--destructive)" }}>Last error: {r.last_error}</span>}
            </div>
            <StatusPill status={r.status} />
            {r.status !== "disconnected" && (
              <button className="ghost-btn small" data-testid={`connection-disconnect-${r.id}`} onClick={() => disconnect(r)}>Disconnect</button>
            )}
          </div>
        ))}
        {rows && !rows.length && <div className="empty-cell">Nobody has connected an account yet</div>}
        {!rows && <div className="empty-cell">Loading...</div>}
      </div>
    </div>
  );
}
